import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TRoleTypeReportingType {
  id: number;
  roleTypeCode: string;
  reportingTypeCode: string;
}

export interface IRoleTypeReportingType extends TRoleTypeReportingType {}

const RoleTypeReportingType = Model(
  (model: TRoleTypeReportingType): IRoleTypeReportingType => {
    const _roleTypeReportingType: TRoleTypeReportingType = Object.assign(
      {},
      model
    );

    let create = (
      roleTypeReportingType: IRoleTypeReportingType
    ): IRoleTypeReportingType => {
      let obj = ValidatableObject(roleTypeReportingType);
      return obj;
    };
    let roleTypeReportingType = {
      get id() {
        return _roleTypeReportingType.id;
      },
      set id(value) {
        _roleTypeReportingType.id = value;
      },
      get roleTypeCode() {
        return _roleTypeReportingType.roleTypeCode;
      },
      set roleTypeCode(value) {
        _roleTypeReportingType.roleTypeCode = value;
      },
      get reportingTypeCode() {
        return _roleTypeReportingType.reportingTypeCode;
      },
      set reportingTypeCode(value) {
        _roleTypeReportingType.reportingTypeCode = value;
      }
    };

    return create(roleTypeReportingType);
  }
);

export default RoleTypeReportingType;
